import { put, takeLatest, call } from "redux-saga/effects";
import * as types from "../../actionTypes";
import AxiosInstance from "../../../services/AxiosInstance";
import { showToast } from "../../../Components/Common/Toast";
import { deleteResumeFailure, deleteResumeSuccess } from "./actions";

function* removeAvatar(action) {
  try {
    const response = yield call(() =>
      AxiosInstance().post("/jobseeker/remove_profile_image", action.payload)
    );
    console.log("updatePersonalInfo", response);
    if (response.data.status) {
      yield put({
        type: types.REMOVE_JOBSEEKER_AVATAR_SUCCESS,
        payload: response.data,
      });
    } else {
      yield put({
        type: types.REMOVE_JOBSEEKER_AVATAR_FAILURE,
        payload: response.data,
      });
    }
  } catch (error) {
    yield put({
      type: types.REMOVE_JOBSEEKER_AVATAR_FAILURE,
      payload: { status: false, message: error.message },
    });
  }
}

function* removeAvatarSaga() {
  yield takeLatest(types.REMOVE_JOBSEEKER_AVATAR_REQUEST, removeAvatar);
}

export default removeAvatarSaga;
